import React, { useEffect, useState } from 'react';
import { getClassName } from '@onsolve/utils.get-class-name';
import styles from './ResponseSelection.module.scss';
import { Button, Typography, LoadingSpinner, RadioGroup, Radio } from '@onsolve/onsolve-ui-components';
import StickyButtonBar from './StickyButtonBar';
import { t } from '@lingui/macro';
const ResponseSelection = ({ response, isLoading, confirmResponse, isSaveBtnDisabled }) => {
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'responseSelection-page',
        styles,
    });
    const resId = response?.['response'];
    const [selectedResponse, setSelectedResponse] = useState(undefined);
    const handleSelectionChange = (_, selectionValue) => {
        setSelectedResponse(selectionValue?.value);
    };
    const handleResponseChange = (selectionValue) => {
        confirmResponse(selectedResponse);
    };
    useEffect(() => {
        setSelectedResponse(() => resId);
    }, [resId]);
    return (<div className={`${rootClass}`}>
            <Typography variant={'p18'} className="m-0">
                {t `Alert Reply`}
            </Typography>
            {isLoading ? (<div className="mx-auto text-center my-4">
                    <LoadingSpinner logoType={'newLogo'} size="xxl"/>
                </div>) : (<div className={getChildClass('responseOption-wrapper')}>
                    <Typography variant={'p16'} className="mt-2 mb-4">
                        {t `Do you want to save your response?`}
                    </Typography>

                    {response && response.responseOptions && response.responseOptions.length > 0 && (<div className="my-4">
                            <RadioGroup value={selectedResponse} onChange={handleSelectionChange} className={'ml-1'} name={'responseOption'}>
                                {response.responseOptions?.map((item, index) => (<Radio className="mb-2" key={item?.id} label={item?.verbiage?.text[0]?.value} value={item?.id} type={'radio'}/>))}
                            </RadioGroup>
                        </div>)}
                </div>)}
            <StickyButtonBar rightContent={<Button color="primary" variant="raised" className="px-4" onClick={() => handleResponseChange(selectedResponse)} disabled={isSaveBtnDisabled}>
                        {t `Confirm Response`}
                    </Button>}/>
        </div>);
};
export default ResponseSelection;
